module.exports = __webpack_public_path__ + "static/media/epic_shield.0eb42bd4.png";